import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { TripBuilderStepType } from "@modules/tripBuilder/TripBuilderStepType";
import { TripDuration, GroupComposition } from "@dto/TripBuilder";

interface TripBuilderState {
  isOpen: boolean;
  currentStep: TripBuilderStepType;
  tripDuration: TripDuration | null;
  groupComposition: GroupComposition | null;
  userPreferenceIds: number[];
}

const initialState: TripBuilderState = {
  isOpen: false,
  currentStep: "tripDuration",
  tripDuration: null,
  groupComposition: null,
  userPreferenceIds: [],
};

export const tripBuilderSlice = createSlice({
  name: "tripBuilder",
  initialState,
  reducers: {
    openTripBuilder: (state) => {
      state.isOpen = true;
    },
    closeTripBuilder: () => initialState,
    setCurrentStep: (state, action: PayloadAction<TripBuilderStepType>) => {
      state.currentStep = action.payload;
    },
    setTripDuration: (state, action: PayloadAction<TripDuration>) => {
      state.tripDuration = action.payload;
    },
    setGroupComposition: (
      state,
      action: PayloadAction<GroupComposition | null>,
    ) => {
      state.groupComposition = action.payload;
    },
    setUserPreferenceIds: (state, action: PayloadAction<number[]>) => {
      state.userPreferenceIds = action.payload;
    },
  },
});

export const selectIsOpen = (state: RootState) => {
  return state.tripBuilder.isOpen;
};

export const selectCurrentStep = (state: RootState) => {
  return state.tripBuilder.currentStep;
};

export const selectTripDuration = (state: RootState) => {
  return state.tripBuilder.tripDuration;
};

export const selectGroupComposition = (state: RootState) => {
  return state.tripBuilder.groupComposition;
};

export const selectUserPreferenceIds = (state: RootState) => {
  return state.tripBuilder.userPreferenceIds;
};

export const {
  openTripBuilder,
  closeTripBuilder,
  setTripDuration,
  setGroupComposition,
  setUserPreferenceIds,
  setCurrentStep,
} = tripBuilderSlice.actions;

// eslint-disable-next-line import/no-default-export
export default tripBuilderSlice.reducer;
